/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

import flatten from './flatten';
import multiFilter from './multiFilter';
import repeatedValues from './repeatedValues';
import randomNumbers from './randomNumbers';
import sumValues from './sumValues';

export default {
  flatten,
  multiFilter,
  repeatedValues,
  randomNumbers,
  sumValues,
};
